import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { SquaresFour, Headset, ShieldCheck, ClockClockwise, ListChecks, CaretDown, Check } from "@phosphor-icons/react";

const MODULES = [
  { key: "itsm", label: "ITSM", to: "/", icon: Headset, match: (p) => !p.startsWith("/soc") && !p.startsWith("/timesheet") && !p.startsWith("/tasks"),
    access: (u) => ["admin", "manager", "agent"].includes(u?.role) },
  { key: "soc", label: "SOC", to: "/soc", icon: ShieldCheck, match: (p) => p.startsWith("/soc"),
    access: (u) => ["admin", "soc_analyst", "soc_lead", "soc_auditor"].includes(u?.role) },
  { key: "timesheet", label: "Timesheet", to: "/timesheet", icon: ClockClockwise, match: (p) => p.startsWith("/timesheet"),
    access: (u) => ["admin", "manager", "agent", "timesheet_admin", "soc_lead"].includes(u?.role) || !!u?.timesheet_access || !!u?.timesheet_role },
  { key: "tasks", label: "Tasks", to: "/tasks", icon: ListChecks, match: (p) => p.startsWith("/tasks"),
    access: (u) => !!u && !["end_user", "soc_viewer"].includes(u.role) },
];

export function ModuleSwitcher() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const auth = useAuth();
  const user = auth?.user;
  const modules = MODULES.filter((m) => m.access(user));
  if (modules.length <= 1) return null;
  const current = modules.find((m) => m.match(pathname)) || MODULES.find((m) => m.match(pathname)) || modules[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="module-switcher"
          className="flex items-center gap-1.5 h-8 px-2.5 rounded-sm border border-sidebar-border dark:border-border text-[11px] font-mono uppercase tracking-wider text-sidebar-foreground dark:text-foreground hover:bg-white/10 dark:hover:bg-accent/40 transition-colors">
          <SquaresFour size={14} /> {current.label} <CaretDown size={10} className="opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="module-switcher-menu" className="w-44">
        {modules.map((m) => {
          const MIcon = m.icon;
          const active = m.key === current.key;
          return (
            <DropdownMenuItem key={m.key} data-testid={`module-switch-${m.key}`} onClick={() => nav(m.to)} className="gap-2 text-sm cursor-pointer">
              <MIcon size={15} className="text-muted-foreground" /> {m.label}
              {active && <Check size={14} className="ml-auto text-primary" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
